import { cn } from '@nucleus-commerce/ui/lib/utils';

/** The Nucleus gem outline in the primary (gold) colour. Decorative; label it in context. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 28 28"
      fill="none"
      aria-hidden
      className={cn('text-primary size-7 shrink-0', className)}
    >
      <path
        d="M14 2 26 10 14 26 2 10Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M2 10h24M14 2 9 10l5 16 5-16-5-8"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
